import React from "react";
import PublicFooter from "./PublicFooter";
import PublicHeader from "./PublicHeader";
import { resolvePublicShellStyle } from "../../config/publicShellConfig";

export default function PublicSiteShell({
  mode = "marketing",
  activeAuthPath = null,
  pageClassName = "",
  pageProps = {},
  topBandTone = "light",
  hero = null,
  children = null,
  footer = true,
  shellPreset = "",
}) {
  const pageClassNames = ["public-core-page", pageClassName].filter(Boolean).join(" ");
  const { style: pageStyle = {}, ...restPageProps } = pageProps || {};
  const shellStyle = {
    ...resolvePublicShellStyle({ mode, shellPreset, pageClassName }),
    ...pageStyle,
  };

  return (
    <div className={pageClassNames} style={shellStyle} {...restPageProps}>
      <PublicHeader mode={mode} activeAuthPath={activeAuthPath} tone={topBandTone} />

      {hero ? (
        <section className={`public-core-band public-core-band--${topBandTone}`}>
          {hero}
        </section>
      ) : null}

      {children}

      {footer ? <PublicFooter /> : null}
    </div>
  );
}
